<template>
    <b-modal size="xl" ref="priceModal" tabindex="-1" role="dialog" id="priceModal">
        <div class="container-fluid" id="ccform">
            <div class="row">
                <div class="form-group col-12">
                    <p class="bold">There is a cost of ${{backgroundCharge}} for the GoodHire Background Check.  We do not hold any of the information put into this form.  Once authorized, you will be taken to your information page to fill in any additional information.</p>
                </div>
                <div class="form-group col-12">
                    <p>Bill To:</p>
                </div>
                <input type="hidden" v-model=companyFein name="billingCompanyFein" />
                <input type="hidden" v-model=backgroundCharge name="cost" />
                <input type="hidden" v-model=email name="email" />
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="billingFirstName">First Name <span class="req">*</span></label>
                    <input type="text" tabindex="1" class="form-control" v-model=firstName v-on:keyup="checkForHighlight" id="billingFirstName" placeholder="Billing First Name">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="billingLastName">Last Name <span class="req">*</span></label>
                    <input type="text" tabindex="2" class="form-control" v-model=lastName v-on:keyup="checkForHighlight" id="billingLastName" placeholder="Billing Last Name">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="billingCompany">Company</label>
                    <input type="text" tabindex="3" class="form-control" v-model=company v-on:keyup="checkForHighlight" id="billingCompany" placeholder="Billing Company">
                </div>
                <div class="form-group col-12">
                    <label class="d-none d-sm-block" for="billingAddress">Address <span class="req">*</span></label>
                    <input type="text" tabindex="4" class="form-control" v-model=address v-on:keyup="checkForHighlight" id="billingAddress" placeholder="Billing Address">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="billingCity">City <span class="req">*</span></label>
                    <input type="text" tabindex="5" class="form-control" v-model=city v-on:keyup="checkForHighlight" id="billingCity" placeholder="Billing City">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="billingState">State <span class="req">*</span></label>
                    <input type="text" tabindex="6" class="form-control" v-model=state v-on:keyup="checkForHighlight" id="billingState" placeholder="Billing State">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="billingZipcode">ZipCode <span class="req">*</span></label>
                    <input type="text" tabindex="7" class="form-control" v-model=zipcode v-on:keyup="checkForHighlight" id="billingZipcode" placeholder="Billing ZipCode">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="cardNumber">Credit Card Number <span class="req">*</span></label>
                    <input type="text" tabindex="8" class="form-control" v-on:keyup="checkForHighlight" v-model=ccNumber id="creditCardNumber" placeholder="Billing CC Number">
                </div>
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="cardExpiration">Credit Card Expiration <span class="req">*</span></label>
                    <input type="text" tabindex="9" v-mask="'##/####'" class="form-control" v-on:keyup="checkForHighlight" v-model=ccExp id="cardExpiration" placeholder="Billing CC Expiration" />
                </div>
                <div class="form-group col-12 col-md-4">
                    <label class="d-none d-sm-block" for="cardCode">Credit Card Code <span class="req">*</span></label>
                    <input type="text" tabindex="10" class="form-control"  v-on:keyup="checkForHighlight" v-model=ccCVS id="cardCode" placeholder="Billing CC Code">
                </div>
                <div class="form-group col-12 row justify-content-center">
                    <button id="submitBtn" class="col-12 col-md-6" tabindex="11" v-on:click="submitForm" >Submit Your Billing Information</button>
                </div>
            </div>
        </div>
        <div class="container-fluid bold bigger center" id="ccConfirm">
            Your submission has been sent.  Please wait while we redirect you.  Please wait.
        </div>
    </b-modal>
</template>

<script>
import axios from 'axios';
import {mask} from 'vue-the-mask';

export default {
  name: 'PaymentInterstitial',
  directives: {mask},
  props: {
    backgroundCharge: Number,
    firstName: String,
    lastName: String,
    address: String,
    city: String,
    state: String,
    email: String,
    zipcode: String,
    companyFein: String,
    company: String
  },
  data: function() {
    return {
        ccNumber: null,
        ccExp: "",
        ccCVS: null
    }
  },
  methods: {
    checkForHighlight: function(e) {
      if(e.srcElement.id == 'cardExpiration' && !isNaN(e.key)) {
          if(e.target.value.length == 1 && parseInt(e.target.value) !== 1 && parseInt(e.target.value) !== 0) {
              e.target.value = '0' + e.target.value;
          }
          if(e.target.value.length == 2) {
              e.target.value = e.target.value + '/20';
          }
      }
      if(e.currentTarget.classList.contains("highlight")) {
        e.currentTarget.classList.remove("highlight");
      }
    },
    showModal() {
      let payModal = this;
      payModal.$refs['priceModal'].show();
      payModal.$emit('hideLoading');
    },
    hideModal() {
      this.$refs['priceModal'].hide();
      this.$emit('hideLoading');
    },
    onCCNumUpdate (newValue) {
      this.ccNumber = newValue;
    },
    onCCCvsUpdate (newValue) {
      this.ccCVS = newValue;
    },
    onCCExpUpdate (newValue) {
      this.ccExp = newValue;
    },
    submitForm: function() {
      let payModal = this;
      let submitObj = {};
      const date = this.ccExp.split('/');
      let ccExp = new Date(parseInt(date[1]), parseInt(date[0])-1);
      let subBtn = document.getElementById("submitBtn");
      submitObj.firstName        = payModal.firstName;
      submitObj.lastName         = payModal.lastName;
      submitObj.companyName      = payModal.company;
      submitObj.companyFein      = payModal.companyFein;
      submitObj.email            = payModal.email;
      submitObj.address          = payModal.address;
      submitObj.city             = payModal.city;
      submitObj.state            = payModal.state;
      submitObj.postalCode       = payModal.zipcode;
      submitObj.creditCardNumber = document.getElementById("creditCardNumber").value;
      submitObj.cardExpiration   = ccExp.getFullYear() + "-" + (ccExp.getMonth()+1);
      submitObj.cardCode         = document.getElementById("cardCode").value;
      submitObj.amount           = payModal.backgroundCharge;
      subBtn.disabled = true;
      axios.post("https://aremcovendors.com/wp-content/plugins/vue-form/excelApi/submitCCRequest.php", submitObj)
      .then(function(response){
          if(response.data.Status == '200') {
            payModal.$emit('changeInterstitialComplete', true);
            payModal.$emit('testStatusInter');
          } else {
            subBtn.disabled = false;
            alert("There was an error in processing your card.\nPlease contact us directly at 1-888-650-0093\nor through the contact form on this site.")
          }
      });
    }
  },
  events:{
    'firstNameUpdate' : function(data){
        this.firstName = data;
    },
    'lastNameUpdate' : function(data){
        this.lastName = data;
    },
    'addressUpdate' : function(data){
        this.address = data;
    },
    'cityUpdate' : function(data){
        this.city = data;
    },
    'stateUpdate' : function(data){
        this.state = data;
    },
    'emailUpdate' : function(data){
        this.email = data;
    },
    'zipUpdate' : function(data){
        this.zipcode = data;
    },
    'bgChargeUpdate' : function(data){
        this.backgroundCharge = data;
    }
  }
}
</script>
<style>
#priceModal___BV_modal_footer_ { display: none !important; }
#ccConfirm { display: none; }
.bigger  {font-size: 30px!important;font-weight: 500;line-height: 1.2;}
.center { text-align: center; }
</style>